import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		telerouteUsername: Yup.string()
			.required(t("fill_required_fields"))
			.test(
				"isNotEmail",
				t("teleroute_dont_use_email_as_username"),
				(value) => !value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
			),
	});
};
